import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(4, 0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1 9H9.00781L9 7L11.5 9.5L9 12L9.00781 10H1C0.447715 10 0 9.55228 0 9V0H1V9Z",
			fill: "black"
		})
	})
});
export default SvgArrowDownRight;
